import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Slider from "react-slick";
import {FaArrowLeft, FaArrowRight} from "react-icons/fa";
import {parseImg} from "../utils/parseImg";
import {CATALOG_ROUTE, PICTURES_PATH} from "../utils/consts";
import {NavLink, useNavigate} from "react-router-dom";
import product from "../pages/Product";

const Modal = () => {
    const showModal = useSelector(state => state.modal.show);
    const modalData = useSelector(state => state.modalData);
    const dispatch = useDispatch();
    const aImg = parseImg(modalData.img) || [];
    const [currentImgIndex, setCurrentImgIndex] = useState(0);
    const [countProduct, setCountProduct] = useState(1);
    const navigate = useNavigate();

    const PrevArrow = ({onClick}) => (
        <button className="slick-arrow prev" onClick={onClick}>
            <FaArrowLeft color="#79a206"/>
        </button>
    );

    // Кастомная кнопка "вперёд"
    const NextArrow = ({onClick}) => (
        <button className="slick-arrow next" onClick={onClick}>
            <FaArrowRight color="#79a206"/>
        </button>
    );

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: true,
        prevArrow: <PrevArrow/>, // Кастомная кнопка назад
        nextArrow: <NextArrow/>  // Кастомная кнопка вперёд
    };

    const hideModal = () => {
        dispatch({type: 'HIDE_MODAL'});
    };

    const goToProduct = (id) => {
        navigate(`${CATALOG_ROUTE}/${id}`)
    }

    return (
        <div>
            <div className={`modal fade ${showModal && 'show'}`}
                 style={{display: showModal && 'block', paddingRight: showModal && '17px'}} role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <button onClick={(e) => {
                            hideModal();
                        }} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span><i className="icon-x"></i></span>
                        </button>
                        <div className="modal_body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-5 col-md-5 col-sm-12">
                                        <div className="modal_tab">
                                            <div className="tab-content product-details-large">
                                                {aImg.map((elem, index) => (
                                                    <div key={index} className={`tab-pane fade ${index === currentImgIndex && 'show active'}`}>
                                                        <div className="modal_tab_img">
                                                            <img className="product-modal-tab-img"
                                                                             src={`${PICTURES_PATH}product/${elem}`} alt={modalData.title}/>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="modal_tab_button">
                                                <ul className="" role="tablist">
                                                    <Slider {...settings}>
                                                        {aImg.map((elem, index) => (
                                                            <li key={index}>
                                                                <a className="nav-link active" href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setCurrentImgIndex(index);
                                                                }}><img
                                                                    className="product-details-tab-under-img"
                                                                    src={`${PICTURES_PATH}product/${elem}`} alt={modalData.title}/></a>
                                                            </li>
                                                        ))}
                                                    </Slider>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 col-md-7 col-sm-12">
                                        <div className="modal_right">
                                            <div className="modal_title mb-10">
                                                <h2>{modalData.title}</h2>
                                            </div>
                                            <div className="modal_price mb-10">
                                                <span className="new_price">{modalData.price}</span>
                                            </div>
                                            <div className="modal_description mb-15">
                                                <p>{modalData.description}</p>
                                            </div>
                                            <div className="product_variant color">
                                                <h3>Характеристики</h3>
                                                <div className="product_meta">
                                                    <p>Порода древесины: <span>{modalData.species}</span></p>
                                                    <p>Категория: <span>{modalData.sort}</span></p>
                                                    <p>Сечение: <span>{modalData.size}</span></p>
                                                    {/*<p>Длина: <span>2000;2500;2700;3000</span></p>*/}
                                                </div>
                                            </div>
                                            <div className="variants_selects">
                                                <div className="modal_add_to_cart">
                                                    <form action="#">
                                                        <button onClick={(e) => {
                                                            e.preventDefault();
                                                            goToProduct(modalData.id);
                                                        }}>Перейти к товару</button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div onClick={(e) => {
                hideModal();
            }} className={showModal && 'modal-backdrop fade show'}></div>
        </div>
    );
};

export default Modal;